/* AlpineJS is our main JS utility framework, doc here : https://alpinejs.dev/start-here */
import Alpine from 'alpinejs';
import { CountUp } from './common/CountUp.js'
import { initAlpineJs } from './common/Alpine.js';

import BiggerPicture from "bigger-picture";

import Slider from "./common/Slider.js";
import Map from "./blocks/Map.js";
import ArchiveAdherent from './ajax/ArchiveAdherent.js';
import AdherentPrefill from './ajax/AdherentPrefill.js';
import FormModifPrefill from './ajax/FormModifPrefill.js';
import MapMembers from './blocks/MapMembers.js';
import LoginForm from './blocks/LoginForm.js';

/**
 * Our document is ready
 */
document.addEventListener('DOMContentLoaded', () => {

  /* Fix mobile display */
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  /* Starts Alpine */
  window.Alpine = Alpine
  Alpine.start();

  //Init map
  const map = document.querySelector('[data-hwc-map]');
  if (map) {
    new Map(map);
  }

  //Init ArchiveAdherent
  const ArchiveAdherentPage = document.querySelector('.hwc-ArchiveAdherent');
  if (ArchiveAdherentPage) {
    new ArchiveAdherent(ArchiveAdherentPage);
  }

  //Init AdherentPrefill (formulaire ré-adhésion #159)
  const adherentPrefillForm = document.querySelector('#wpforms-159');
  if (adherentPrefillForm) {
    new AdherentPrefill(adherentPrefillForm);
  }

  //Init FormModifPrefill (formulaire modification adhérent #587)
  const formModif = document.querySelector('#wpforms-587');
  if (formModif) {
    new FormModifPrefill(formModif);
  }

  //Init map Members
  const mapMembers = document.querySelector('[data-hwc-map-Members]');
  if (mapMembers) {
    new MapMembers(mapMembers);
  }

  // Auth Form 
  if (document.querySelector('[data-hwc-login-form]')) {
    new LoginForm(document.querySelector('[data-hwc-login-form]'));
  }

  /* Count Up Triggers */
  const countUpObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        new CountUp(entry.target, parseInt(entry.target.textContent), { separator: '', duration: 3 }).start()
        countUpObserver.unobserve(entry.target);
      }
    });
  }, { root: null, threshold: 0, rootMargin: '-50px' });
  document.querySelectorAll('.js-countup')?.forEach((el) => {
    countUpObserver.observe(el);
  })

  /* Init slider with swiper */
  const sliders = [...document.querySelectorAll('[data-hwc-slider]')];
  if (sliders.length) {
    sliders.forEach((slider) => {
      new Slider(slider);
    })
  }

  /* Init gallery with bigger picture */
  if (typeof BiggerPicture === "function") {

    let bp = BiggerPicture({
      target: document.body
    });

    if (document.querySelectorAll('[data-hwc-lightbox]').length) {
      document.querySelectorAll('[data-hwc-lightbox]').forEach((lightbox) => {
        const links = [...lightbox.querySelectorAll('[data-lightbox-link]')];
        for (let link of links) {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            bp.open({
              items: links,
              el: e.currentTarget,
              intro: 'fadeup',
              scale: 0.9,
            });
          });
        }
      })
    }
  }

  let vw = window.innerWidth;

  //resp gallery
  const galleryBlock = document.querySelectorAll('.hwc-BlockGallery');
  if (galleryBlock.length && vw < 880) {
    galleryBlock.forEach(block => {

      const itemContainer = block.querySelector('.hwc-BlockGallery-items');

      if (itemContainer.classList.contains('is-slider')) {

        const btnPrev = block.querySelector('.swiper-button-prev');
        const btnNext = block.querySelector('.swiper-button-next');
        const pag = block.querySelector('.swiper-pagination');
        const nav = block.querySelector('.hwc-BlockGallery-nav');

        nav.appendChild(btnNext);
        nav.insertBefore(btnPrev, pag);
      }
    });
  }

  //resp logo
  const logoBlock = document.querySelectorAll('.hwc-BlockLogos');
  if (logoBlock.length && vw < 880) {
    logoBlock.forEach(block => {

      const btnPrev = block.querySelector('.swiper-button-prev');
      const btnNext = block.querySelector('.swiper-button-next');
      const pag = block.querySelector('.swiper-pagination');
      const nav = block.querySelector('.hwc-BlockLogos-nav');

      nav.appendChild(btnNext);
      nav.insertBefore(btnPrev, pag);
    });
  }

  /* Adds class to body if it's domready */
  document.body.classList.add('is-domready');

  /* Replace <a> by <div> in menu */
  /* document.querySelectorAll('.hwc-MenuInline-link[href="#"]').forEach(link => {
    const div = document.createElement('div');
    div.innerHTML = link.innerHTML;
    div.classList.add('hwc-MenuInline-link');
    link.parentNode.replaceChild(div, link);
  }); */

})

/**
 * Our window is fully loaded
 */
window.addEventListener('load', () => {
  /* Adds class to body if it's loaded  */
  document.body.classList.add('is-loaded')
})

/**
 * Components instanciation
 */
document.addEventListener('alpine:init', () => {
  initAlpineJs();
})

/**
 * Listen to the resize event
 */
window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});
